export default "__VITE_ASSET__Cnneetg___"